// extracted by mini-css-extract-plugin
export default {"icon":"JxomlH","link":"Qj3qcp","hidden":"CQClU5","profile-image":"GTb_uk","profileImage":"GTb_uk","wrapper":"qxv6hG","button":"RqR2_d","panel":"cbl11a"};